"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var category_1 = require("./data/category");
exports.CalendarOptions = category_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-options-calendar/lib/index.js
// module id = 3764
// module chunks = 2